import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import {
  HotelSaleAddOnsItemFormType,
  HotelSaleFormType,
  HotelSaleHotelItemFormType,
} from '../form-type';

export function calculateHotelSaleAddons(
  addons: HotelSaleAddOnsItemFormType[],
) {
  const total = addons.reduce((prev, hsao) => prev + (hsao.price || 0), 0);
  return total;
}

export function calculateHotelSaleDetail(
  hotel: HotelSaleHotelItemFormType[],
  isByPax: boolean,
) {
  const total = hotel.reduce((prev, hsg) => {
    const price = hsg.price || 0;
    const night = hsg.night || 0;
    const room = hsg.room || 0;
    const pax = hsg.pax || 0;
    if (isByPax) {
      const total = pax * price;
      return prev + total;
    } else {
      const total = price * night * room;
      return prev + total;
    }
  }, 0);

  return total;
}

export default function useRecalculate() {
  const { control, setValue } = useFormContext<HotelSaleFormType>();
  const [hotelSales, otherCost, discount] = useWatch({
    control,
    name: ['hotelSales', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = hotelSales.reduce((prev, hs) => {
      const subtotalGuest = calculateHotelSaleDetail(
        hs.hotelSaleHotels,
        hs.isByPax,
      );

      const subtotalAddOns = calculateHotelSaleAddons(hs.hotelSaleAddOns);

      return prev + subtotalAddOns + subtotalGuest;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [hotelSales, discount, otherCost, setValue]);

  return data;
}
